import * as React from 'react';
import styled from 'styled-components';

import Box from '@components/layout/box';
import Flex from '@components/layout/flex';
import Button from '@components/actions/button';
import TrackSlider from '@components/actions/slider';
import PlusIcon from '@components/basics/icons/plus';
import MinusIcon from '@components/basics/icons/minus';
import BoxHeader from '@components/layout/box-header';
import { Translate } from 'react-localize-redux';

interface PreviewSliderProps {
  idLow?: string;
  idHigh?: string;
  className?: string;
  duration: number;
  currentStart: number;
  maxTime: number;
  isPlaying: boolean;
  locked?: boolean;
  togglePlay: () => void;
  onUpdate: (value: number) => void;
}

const updateStart = (
  value: number,
  duration: number,
  maxTime: number,
  cb: (value: number) => void,
  ct: (value: number) => void
) => {
  if (duration < 30) {
    return;
  }

  if (value < 0) {
    return;
  }

  if (value <= maxTime) {
    cb(value);
    ct(value);
  }
};

export const PreviewSlider: React.FC<PreviewSliderProps> = (props) => {
  const { currentStart, onUpdate, duration, maxTime, isPlaying } = props;

  const [start, setStart] = React.useState(currentStart);
  const [holding, setHolding] = React.useState(0);

  React.useEffect(() => {
    setStart(currentStart);
  }, [currentStart]);

  const handleUpdate = (start, duration, maxTime, onUpdate) => {
    updateStart(start + holding, duration, maxTime, onUpdate, setStart);
  };

  return (
    <Box className={props.className} noBorderTop noBorderBottom>
      <BoxHeader
        title={<Translate id="RELEASE.TRACK_INFO.TRACK.AUDIO_PREVIEW.TITLE" />}
        text={<Translate id="RELEASE.TRACK_INFO.TRACK.AUDIO_PREVIEW.TEXT" />}
      />
      <Flex
        className="slider-wrapper"
        justifyContent="space-between"
        alignItems="center"
      >
        <Button
          id={props.idLow}
          className="btn"
          buttonType="add"
          onMouseDown={() => setHolding(-1)}
          onMouseUp={() => setHolding(0)}
          onClick={() => handleUpdate(start - 1, duration, maxTime, onUpdate)}
        >
          <MinusIcon color="dark" size={16} />
        </Button>

        {duration ? (
          <TrackSlider
            className="track-slider"
            trackLength={duration}
            startTime={start}
            maxTime={maxTime}
            onChange={
              props.locked
                ? () => null
                : (value) => handleUpdate(value, duration, maxTime, onUpdate)
            }
            isPlaying={isPlaying}
            onTogglePlay={() => props.togglePlay()}
          />
        ) : null}

        <Button
          id={props.idHigh}
          className="btn"
          buttonType="add"
          onClick={() => handleUpdate(start + 1, duration, maxTime, onUpdate)}
          onMouseDown={() => setHolding(1)}
          onMouseUp={() => setHolding(0)}
        >
          <StyledPlusIcon size={16} />
        </Button>
      </Flex>
    </Box>
  );
};

export default styled(PreviewSlider)`
  .slider-wrapper {
    .btn {
      flex: 0 0 50px;
    }
    .track-slider {
      margin: 0 10px;
      flex: 0 0 calc(100% - 100px - 20px);

      @media ${({ theme }) => theme.device.laptopL} {
        margin: 0 20px;
        flex: 0 0 calc(100% - 100px - 40px);
      }
    }
  }
`;

const StyledPlusIcon = styled(PlusIcon)``;
